const testimonials = [
  {
    name: "Captain Mike R.",
    location: "Islamorada, FL",
    rating: 5,
    text: "I've been chartering out of Islamorada for 18 years. Got invited to fish the Bahamas Wahoo Championship with two weeks' notice — pulled my passport and it had expired two months earlier. Fast Passport Center had my renewal in four business days. I made the tournament, placed in the top ten, and landed a 78-pound wahoo. Their team understood tournament travel urgency in a way nobody else did.",
    service: "Passport Renewal",
  },
  {
    name: "Susan T.",
    location: "Islamorada, FL",
    rating: 5,
    text: "My husband and I have a waterfront home in Islamorada and spend half the year here. We booked a Caribbean cruise from Miami for our 40th anniversary and discovered both our passports had expired. We had ten days until embarkation. Fast Passport Center processed both renewals in five business days. We made the cruise, celebrated in St. Thomas, and never missed a port. Absolutely saved our anniversary.",
    service: "Passport Renewal",
  },
  {
    name: "Danny L.",
    location: "Islamorada, FL",
    rating: 5,
    text: "I'm a dive instructor based in Islamorada who leads groups to Cozumel and Belize. One of my regular clients forgot to renew his passport before our Cozumel trip — we were leaving in six days. Fast Passport Center got his renewal processed and delivered in four days. He made the trip, we dove the Palancar Reef, and he signed up for my next Belize expedition. These guys understand dive travel deadlines.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function IslamoradaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Islamorada Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Islamorada anglers, charter captains, dive instructors, and families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}